export default "__VITE_ASSET__E_ccankJ__"